export default __webpack_public_path__ + "static/media/intro-network.62f8900e.jpg";